import "./Header.scss";
import { useNavigate } from "react-router-dom";

import { UiHeader } from "libs/raas-ui-react-components/src/components";
import { IHeaderProps } from "./Header.model";
import { capitalizeFirstLetter, checkIfEmptyObject } from "./Header.util";
import { navigateInformacional, navigateTransactional } from "services/api/navigation.service";
import { LocalRoutes } from "local-routes";
import { IRouteObject } from "models/RouteInterface";
import useSession from "hooks/useSession";
import { getItemStorage, setItemStorage } from "services/util/sessionStorage.service";
import { getHeaderTranslationLiterals } from "./Header.service";
import { useTranslation } from "react-i18next";
import { SessionStorageItems } from "services/user/user.session.service";
import useWindowSize from "hooks/useWindowSize";

export default function Header(props: IHeaderProps) {
  const navigate = useNavigate();
  const { logged, userConnected,stepOnBoarding } = useSession();
  const [t, i18n] = useTranslation('header');
  const { isXSView } = useWindowSize();



  const routeObject = LocalRoutes().find(
    (element: IRouteObject) => element?.path === props?.location?.pathname
  );

  const navigateToExternalPath = (path: string) => {
    navigateInformacional(path)
    
  };

  const navigateToInternalPath = (path: string) => {
    navigate(path);
  };

  const _getButtonName = () => {
    const sessionStorageName = getItemStorage(SessionStorageItems.RAAS_USER);
    if(sessionStorageName?.name===null){
      return t('literal.greetingButtonText')
    }else{
   if(capitalizeFirstLetter(userConnected?.customerFullName?.name)){
    return !checkIfEmptyObject(userConnected)
      ? `${t('literal.greetingButtonText')} ${capitalizeFirstLetter(userConnected?.customerFullName?.name)}`
      : sessionStorageName
        ? `${t('literal.greetingButtonText')} ${sessionStorageName?.name}`
        : null;
    }
    }

 
  };

  const getLoggedButtonText = () => {
    return _getButtonName();
  };

  const changeLang = (lang: string) => {
    const language = mapLang(lang);
    i18n.changeLanguage(language);
    setItemStorage('raas-language', language);
    document.documentElement.setAttribute("lang", language === 'va' ? 'ca' : language);
  }

  const overHeaderActions = (data: any) => {
    if (data.action === "changeLang") changeLang(data.value);
    if (data.action === "download") navigateToExternalPath("/pioneros")
  }

  const mapLang = (value: string) => {
    switch (value) {
      case 'spa': return 'es';
      case 'eng': return 'en';
      case 'gal': return 'gl';
      default: return value.substring(0, 2);
    }
  }

  const HeaderConfiguration = getHeaderTranslationLiterals(t);
  return (
    <div className={routeObject?.private ? 'height-header' : ''}>
      <div className={routeObject?.private ? "header-container" : "header-container-private"}>
        <UiHeader
          user-logged-name={getLoggedButtonText()}
          is-xs-view={isXSView}
          is-logged={logged}
          is-boarding={stepOnBoarding}
          exit-internal-path-back={routeObject?.exitInternalPathBack}
          is-private={isXSView || routeObject?.private} 
          show-header={routeObject?.showHeader}
          navigation={HeaderConfiguration.navigation}
          literals={HeaderConfiguration.literals}
          onExternalNavbarEventClick={(e) => { navigateToExternalPath(e?.detail); }}
          onInternalNavbarEventClick={(e) => { navigateToInternalPath(e?.detail); }}
          onOverHeaderEventClick={(e) => { overHeaderActions(e.detail) }}
        ></UiHeader>
      </div>
    </div>
  );
}